import { render, staticRenderFns } from "./ChoiceValuesExtractor.vue?vue&type=template&id=0190f0f5&scoped=true&"
import script from "./ChoiceValuesExtractor.vue?vue&type=script&lang=ts&"
export * from "./ChoiceValuesExtractor.vue?vue&type=script&lang=ts&"
import style0 from "./ChoiceValuesExtractor.vue?vue&type=style&index=0&id=0190f0f5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0190f0f5",
  null
  
)

export default component.exports